'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Head = require('next/head');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Head__default = /*#__PURE__*/_interopDefaultLegacy(Head);

function PlausibleProvider(props) {
    var _a = props.customDomain, customDomain = _a === void 0 ? 'https://plausible.io' : _a, _b = props.enabled, enabled = _b === void 0 ? process.env.NODE_ENV === 'production' : _b;
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement(Head__default['default'], null, enabled && (React__default['default'].createElement("script", { async: true, defer: true, "data-domain": props.domain, "data-exclude": props.exclude, src: customDomain + "/js/" + (props.selfHosted || customDomain === 'https://plausible.io'
                ? 'plausible'
                : 'index') + (props.exclude ? '.exclusions' : '') + ".js", integrity: props.integrity, crossOrigin: props.integrity ? 'anonymous' : undefined }))),
        props.children));
}
function usePlausible() {
    return function (eventName) {
        var _a, _b;
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return (_b = (_a = window).plausible) === null || _b === void 0 ? void 0 : _b.call(_a, eventName, rest[0]);
    };
}

exports.default = PlausibleProvider;
exports.usePlausible = usePlausible;
//# sourceMappingURL=index.js.map
